module.exports = {
    APPURL: window.location.href.includes('localhost') ? 'http://localhost:3000' : 'https://coga-frontend.vercel.app',
    BASEURL: window.location.href.includes('localhost') ? 'http://localhost:8001/api' : 'https://coga-backend.onrender.com/api',
    LOGIN: "/login",
    EXPENSES_MONTH: "/expense/:year/:month",
  };
  